import { render, staticRenderFns } from "./shareDetails.vue?vue&type=template&id=6933e14d"
import script from "./shareDetails.vue?vue&type=script&lang=js"
export * from "./shareDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports